// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3VyAg","title":"FrontImage_title__1JJD_"};